module.exports = __webpack_public_path__ + "static/USgov.77dc7a9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/USgov.svg
// module id = 434
// module chunks = 35783957827783